import { ReactElement, useMemo } from "react";

import { ICatalogueCustomization } from "../../../apis/useGetCatalogueData/types";
import I18nText from "../../../components/I18nText/I18nText";
import CartItemCustomizationOptions from "./CartItemCustomizationOptions";

interface IProps {
	customizations: ICatalogueCustomization[];
}

const CartItemCustomizations = ({ customizations }: IProps): ReactElement => {
	const customizationsWithOptions = useMemo(
		() =>
			customizations.filter(
				(custom) =>
					custom.food_supplier_customization_options &&
					custom.food_supplier_customization_options.length > 0
			),
		[customizations]
	);

	return (
		<ul className="CartItemCustomizations">
			{customizationsWithOptions.map((custom) => {
				return (
					<li className="Customization" key={custom.id}>
						<div className="CustomizationTitle">
							<I18nText enText={custom.title} cnText={custom.title_cn} />:
						</div>
						<CartItemCustomizationOptions options={custom.food_supplier_customization_options!} />
					</li>
				);
			})}
		</ul>
	);
};

export default CartItemCustomizations;
